import * as React from 'react';

import classNames from 'classnames';

import {Badge} from '../../badge/badge';
import {colors} from '../../colors/colors';
import type {Variant} from '../../control-bar/page-control-bar';
import {StatusBadge} from '../../status-badge/status-badge';
import {Body} from '../../typography/body';

import {getActiveColor} from './helpers';
import type {Tab as TabProps} from './page-tabs';

import styles from './page-tab.module.css';

type Props = TabProps & {
    lessPadding?: boolean;
    variant?: Variant;
};

export function PageTab(props: Props) {
    const {Icon, label, isActive, lessPadding, variant} = props;

    const isAiVariant = variant === 'ai';
    const activeColor = getActiveColor(variant);

    const tabStyle = classNames(styles.tab, {
        [styles['tab--selected']]: isActive,
        [styles['tab--selected-ai']]: isActive && isAiVariant,
        [styles['tab--less-padding']]: lessPadding,
    });

    return (
        <button onClick={props.onClick} autoFocus={false} className={tabStyle}>
            {Icon ? (
                <Icon
                    size={18}
                    fill={props.isActive ? activeColor : colors.grey}
                    color={props.isActive ? activeColor : colors.grey}
                    style={{color: props.isActive ? activeColor : colors.grey}}
                    wrapWithDiv={false}
                />
            ) : undefined}
            {label && <Body size='normal'>{label}</Body>}
            {props.count && <StatusBadge level='info' size='tiny' text={props.count} />}
            {props.badgeColor && (
                <div className='pos-relative pb-8 pl-4'>
                    <Badge color={props.badgeColor} />
                </div>
            )}
        </button>
    );
}
